import React from 'react';
import classNames from 'classnames';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';
import { NumberParam, useQueryParam } from 'use-query-params';

import { globalConst } from 'modules/global';
import { useAllNewsCategory } from 'modules/news';


const ArticleCategoryList = () => {
  const t = useTranslations();
  const { locale } = useRouter();
  const { newsCategory } = useAllNewsCategory(globalConst.langIds[locale || 'uz']);

  const [categoryId, setCategoryId] = useQueryParam('category_id', NumberParam);

  const allCategories = [
    {
      name: t('barchasi'),
      category_id: 0
    },
    ...(newsCategory || [])
  ];

  const handleSubjectClick = (id: number) => {
    if (id === 0) {
      setCategoryId(undefined);
    } else {
      setCategoryId(id);
    }
  };

  return (
    <div>
      <div className="md:rounded-2xl bg-white p-3 pb-0 md:shadow-md sm:col-span-1 mb-5 overflow-x-auto">
        <p className="mb-3 text-xs text-gray-400 hidden md:block">{t('Kategoriya')}</p>
        <ul className='flex gap-5 md:block'>
          {allCategories?.map(item => {
            const isActive = (categoryId || 0) === item?.category_id;

            return (
              <li
                key={item?.category_id}
                className={classNames(`cursor-pointer items-center md:rounded-md md:py-2 md:pl-2 pb-2`, {
                  transparent: !isActive,
                  'md:border-r-3 border-b-3 md:border-b-0 border-green-500 md:bg-green-50': isActive
                })}
                onClick={() => handleSubjectClick(item?.category_id)}
              >
                <span className={`${isActive ? 'font-medium text-green-500' : 'font-normal text-black'}`}>
                  {item.name}
                </span>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default ArticleCategoryList;
